var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "scout-form",
    {
      attrs: {
        "is-modified": !!_vm.value.length,
        label: _vm.prefix + "雇用形態",
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "boss-layout boss-layout-start boss-layout-wrap boss-layout-gap-large",
        },
        _vm._l(_vm.employmentStatusMaster, function (option) {
          return _c("div", { key: option.id }, [
            _c(
              "label",
              {
                staticClass: "boss-checkbox",
                attrs: { "data-test": "label-" + option.id },
              },
              [
                _c("input", {
                  staticClass: "boss-input-checkbox",
                  attrs: {
                    "data-test": "checkbox-" + option.id,
                    type: "checkbox",
                  },
                  domProps: {
                    value: option.id,
                    checked: _vm.value.includes(option.id),
                  },
                  on: { change: _vm.onChange },
                }),
                _vm._v(_vm._s(option.name) + "\n      "),
              ]
            ),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }